<template>
  <div class="flex h-screen flex-col overflow-hidden">
    <div class="w-full desktop:pt-8 flex flex-col h-full min-h-0">
      <Header class="hidden desktop:flex desktop:pl-6 desktop:pr-10 flex-shrink-0" />
      <MobileHeader class="desktop:hidden desktop:pl-6 desktop:pr-10 flex-shrink-0" />
      <AdminNavigation class="flex-shrink-0" />
      <main class="flex-1 min-h-0 overflow-y-auto">
        <div class="px-4 desktop:pl-6 desktop:pr-10 h-full">
          <slot />
        </div>
        <Footer class="flex-shrink-0" />
      </main>
      <MobileStickyFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
import MobileStickyFooter from '@/components/MobileStickyFooter.vue'
import Footer from '@/components/Footer.vue'

onMounted(() => {
  if (typeof document !== 'undefined') {
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
  }
})

onUnmounted(() => {
  if (typeof document !== 'undefined') {
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
  }
})
</script>

<style scoped></style>

